/** Fixed Jack Henry core (Silverlake / jXchange) OAuth token endpoint. */
export const JACK_HENRY_CORE_TOKEN_URL =
  'https://login.jackhenry.com/a/oidc-provider/api/v0/token'

/** Fixed Jack Henry core service gateway base URL (SOAP). */
export const JACK_HENRY_CORE_SERVICE_GATEWAY_BASE_URL = 'https://jx.jackhenry.com'

/** Fixed Jack Henry Synergy API base URL. */
export const JACK_HENRY_SYNERGY_BASE_URL = 'https://jxapi.jhahosted.com'

/** Fixed Jack Henry Synergy identity / token endpoint (full URL). */
export const JACK_HENRY_SYNERGY_IDENTITY_ENDPOINT =
  'https://jxapi.jhahosted.com/jxchange/identity/authserver/connect/token'

/** Fixed Jack Henry Synergy product id for REST path segments. */
export const JACK_HENRY_SYNERGY_PRODUCT_ID = 'jha-Synergy'
